// ── Custom cursor ──
const cursor = document.getElementById('cursor');
if (cursor) {
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
  });
  document.querySelectorAll('a, button').forEach(el => {
    el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
    el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
  });
}

// ── Hero: video or image ──
const heroVideo  = document.querySelector('.hero-video');
const heroPoster = document.getElementById('heroPoster');
const heroBg     = document.getElementById('heroBg');
const muteBtn    = document.getElementById('heroMuteBtn');

if (heroVideo) {
  // Hide poster once video is playing smoothly
  heroVideo.addEventListener('playing', () => {
    if (heroPoster) {
      heroPoster.classList.add('hidden');
      setTimeout(() => { if (heroPoster) heroPoster.style.display = 'none'; }, 900);
    }
  });

  // Force play on mobile (some browsers need a gesture, but we try anyway)
  heroVideo.play().catch(() => {
    // If autoplay blocked, keep poster visible
  });

  // Mute / unmute toggle
  if (muteBtn) {
    muteBtn.classList.add('is-muted'); // starts muted
    muteBtn.addEventListener('click', () => {
      heroVideo.muted = !heroVideo.muted;
      muteBtn.classList.toggle('is-muted', heroVideo.muted);
      muteBtn.setAttribute('aria-label', heroVideo.muted ? 'Unmute video' : 'Mute video');
    });
  }

} else if (heroBg) {
  // Image hero: ken-burns load + parallax scroll
  setTimeout(() => heroBg.classList.add('loaded'), 100);
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    heroBg.style.transform = `scale(1) translateY(${y * 0.3}px)`;
  });
}

// ── Scroll reveal ──
const reveals = document.querySelectorAll('.reveal');
if (reveals.length) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.12 });
  reveals.forEach(el => observer.observe(el));
}

// ── Newsletter ──
const newsletterBtn = document.querySelector('.newsletter-btn');
if (newsletterBtn) {
  newsletterBtn.addEventListener('click', function () {
    const input = document.querySelector('.newsletter-input');
    if (input && input.value) {
      this.textContent = 'Subscribed ✓';
      this.style.background = '#0a0a0a';
      input.value = '';
    }
  });
}

// ── Mobile nav drawer ──
const hamburger = document.getElementById('navHamburger');
const drawer    = document.getElementById('mobileNavDrawer');
const overlay   = document.getElementById('mobileNavOverlay');
const closeBtn  = document.getElementById('mobileNavClose');

function openNav() {
  if (!drawer) return;
  drawer.classList.add('open');
  overlay.style.display = 'block';
  setTimeout(() => overlay.classList.add('open'), 10);
  document.body.style.overflow = 'hidden';
}
function closeNav() {
  if (!drawer) return;
  drawer.classList.remove('open');
  overlay.classList.remove('open');
  setTimeout(() => { overlay.style.display = 'none'; }, 300);
  document.body.style.overflow = '';
}

if (hamburger) hamburger.addEventListener('click', openNav);
if (closeBtn)  closeBtn.addEventListener('click', closeNav);
if (overlay)   overlay.addEventListener('click', closeNav);
